import React from 'react';

// Create a context for the current theme (with null as the default).

const ThemeContext = React.createContext(null);
// const ThemeContext = React.createContext(localStorage.getItem('theme') || null);

export default ThemeContext;
